import { isRobotUser } from '../functions/isRobotUser';

interface Props {
  children?: JSX.Element;
}

export const RobotUserOnly = (props: Props) => {
  const { children = null } = props;

  return isRobotUser() ? children : null;
};
